module.exports = __webpack_public_path__ + "img/a2.27a118c5.png";